import React from "react";
import styles from "./chatNotification.css";
import classNames from "classnames";

interface Props {
  message: JSX.Element | string;
}

export const ChatNotification: React.SFC<Props> = ({ message }) => (
  <div className={classNames(styles.event, styles.dashboard)}>
    <div className={styles["event-text"]}>{message}</div>
  </div>
);
